<script lang="ts" setup>
import {IonButton, IonIcon} from '@ionic/vue'
import {shareOutline} from 'ionicons/icons'

interface Props {
    title?: string
    lines?: string[] | (() => string[])
    textOnly?: boolean
    size?: 'small' | 'default' | 'large'
    withIcon?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  size: 'default'
})

const getLines = (): string[] => {
  const lines = typeof props.lines === 'function' ? props.lines() : props.lines
  return lines ?? []
}


const onClick = () => {
    if (!navigator.share) {
        return
    }
    try {
        navigator.share({
            title: props.title,
            text: getLines().join('\n')
        })
    } catch (e) {
        // share cancelled
    }
}
</script>

<template>
<ion-button
    class="share-button"
    :size="props.size"
    :fill="props.textOnly ? 'clear' : 'solid'"
    :class="{'text-only': props.textOnly}"
    @click="onClick">
    <slot>
        Teilen
    </slot>
    <ion-icon
        v-if="props.withIcon"
        slot="end"
        :icon="shareOutline"
    />
</ion-button>
</template>

<style lang="scss">
.share-button {
    &.text-only {
        min-height: 0;
        --padding-top: 0.2em;
        --padding-bottom: 0.2em;
    }
}
</style>
